import React from 'react';
import './loading-spinner.css';

/**
 * Reusable loading spinner component
 * @param {Object} props - Component props
 * @param {string} props.size - Size of spinner: 'full' (default) or 'small'
 * @param {string} props.color - Color of spinner: 'red' (default) or 'default'
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.text - Loading text (default: "Loading...")
 * @returns {JSX.Element} - Loading spinner component
 */
const LoadingSpinner = ({ 
  size = 'full', 
  color = 'red', 
  className = '',
  text = 'Loading...'
}) => {
  // Determine spinner size class
  const spinnerSizeClass = size === 'small' ? 'spinner-border-sm' : '';
  
  // Determine spinner color class
  const spinnerColorClass = color === 'red' ? 'spinner-red' : '';
  
  // Combine classes
  const spinnerClasses = `spinner-border ${spinnerSizeClass} ${spinnerColorClass} ${className}`.trim();
  
  // For small spinners, just return the spinner without container
  if (size === 'small') {
    return (
      <span className={spinnerClasses} role="status" aria-hidden="true">
        <span className="visually-hidden">{text}</span>
      </span>
    );
  }
  
  // For full-size spinners, include the container
  return (
    <div className="loading-container text-center p-5">
      <div className={spinnerClasses} role="status">
        <span className="visually-hidden">{text}</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;